// src/api/checkin.js
import axios from 'axios';

export default {
  // 用户签到
  checkin(userId) {
    return axios.post('/auth-service/api/checkin', null, {
      params: { userId }
    });
  },
  
  // 领取签到奖励
  claimReward(userId) {
    return axios.post('/auth-service/api/checkin/reward', null, {
      params: { userId }
    });
  },
  
  // 查看当月签到详情
  getCurrentMonthCheckins(userId) {
    return axios.get('/auth-service/api/checkin/info', {
      params: { userId }
    });
  },
  
  // 查看指定月份签到详情
  getCheckinInfoByMonth(userId, year, month) {
    return axios.get('/auth-service/api/checkin/info/month', {
      params: { userId, year, month }
    });
  }
};
    